import { Grid, useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useGetIndividualAssetQuery } from '../../../app/Slices/SevenDayApiSlice';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import React, { useEffect } from 'react';
import WaitListRequestContent from '../../components/Reservations/ReservationRequest/WaitListRequestContent';

export default function WaitListRequestPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const navigate = useNavigate();
    const urlRef = window.location.href.split('/')[7];

    const {
        data: getIndividualAsset,
        isFetching,
        error,
    } = useGetIndividualAssetQuery(`modules/${urlRef}`);

    if (error) {
        navigate(`/*`);
    }

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {isFetching === true ? (
                <Grid
                    sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LoadingComponent />
                </Grid>
            ) : (
                <Grid
                    sx={{
                        width: '100%',
                        height: isMobile ? '100%' : '130vh',
                        justifyContent: 'left',
                        alignItems: 'center',
                    }}
                >
                    <Grid
                        sx={{
                            width: '100%',

                            height: isMobile
                                ? '100%'
                                : isIpad
                                  ? '140vh'
                                  : '120vh',
                            paddingBottom: isMobile || isIpad ? '10px' : '0px',
                        }}
                    >
                        <WaitListRequestContent
                            reservationDetails={getIndividualAsset}
                        />
                    </Grid>
                </Grid>
            )}
        </>
    );
}
